const visibilityInfo = {
  on: {
    onVisibilityChange(callback: Function) {
      const listener = () => callback(document.visibilityState);

      document.addEventListener('visibilitychange', listener, false);

      return () => {
        document.removeEventListener('visibilitychange', listener);
      };
    },
  },
};

export default visibilityInfo;
